export default {
    update: {
        success: 'The company-macro-trend {title} was saved successfully.'
    },
    create: {
        success: 'The company-macro-trend {title} was saved successfully.'
    },
    delete: {
        success: 'Der Company-Macro-Trend wurde erfolgreich gelöscht'
    }
}
